import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AdminAuthService from '../services/adminAuthService';

const AdminProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const check = async () => {
      try {
        const auth = await AdminAuthService.isAuthenticated();
        setIsAuthenticated(auth);
      } catch {
        setIsAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };
    check();
  }, []);

  if (loading || isAuthenticated === null) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          flexDirection: 'column',
          gap: '1rem',
          background: '#e7f7eb',
          fontFamily: 'Inter, sans-serif',
        }}
      >
        <div className="spinner" style={{
          width: 32,
          height: 32,
          border: '3px solid #e5e7eb',
          borderTopColor: '#F79009',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
        }} />
        <div style={{ color: '#667085' }}>Checking authentication...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        state={{ message: 'Admin access required. Please log in.', redirectTo: location.pathname }}
        replace
      />
    );
  }

  return children;
};

export default AdminProtectedRoute;
